/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Draggable, Droppable, DragDropContext } from 'react-beautiful-dnd-next';
import { getBox } from 'css-box-model';

import isEmpty from 'lodash/isEmpty';

import { noop } from '../helpers/handy';
import { flattenTree, mutateTree, calculateFinalDropPositions } from '../helpers/tree';
import { getDestinationPath, getItemById, getIndexById } from '../helpers/flat-tree';

import DelayedFunction from '../helpers/delayed-function';

import TreeItem from './nestedRowItem';

export default class NestedRows extends Component {
  static defaultProps = {
    tree: { children: [] },
    onExpand: noop,
    onCollapse: noop,
    onDragStart: noop,
    onDragEnd: noop,
    renderItem: noop,
    offsetPerLevel: 35,
    isNestingEnabled: false,
    isDragEnabled: true,
    isCombineEnabled: false,
    className: '',
    containerHeight: 0,
    limitItemsToOriginalNestedDepth: false,
    renderCustomPlaceholder: noop,
    testId: '',
  };

  static propTypes = {
    tree: PropTypes.shape({
      children: PropTypes.arrayOf(PropTypes.number),
    }),
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func,
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
    renderItem: PropTypes.func,
    offsetPerLevel: PropTypes.number,
    isNestingEnabled: PropTypes.bool,
    isDragEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    isCombineEnabled: PropTypes.bool,
    className: PropTypes.string,
    containerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    limitItemsToOriginalNestedDepth: PropTypes.bool,
    renderCustomPlaceholder: PropTypes.func,
    testId: PropTypes.string,
  };

  static closeParentIfNeeded(tree, draggedItemId) {
    if (draggedItemId) {
      // Closing parent internally during dragging, because visually we can only move one item not a subtree
      return mutateTree(tree, draggedItemId, {
        isExpanded: false,
      });
    }
    return tree;
  }

  static getDerivedStateFromProps(props, state) {
    const { draggedItemId } = state;
    const { tree } = props;

    const finalTree = NestedRows.closeParentIfNeeded(tree, draggedItemId);

    const flattenedTree = flattenTree(finalTree);

    return {
      ...state,
      flattenedTree,
    };
  }

  state = {
    flattenedTree: [],
    draggedItemId: undefined,
    isDisabled: true,
    height: this.containerElement?.offsetHeight,
    placeholderProps: {
      clientX: null,
      clientY: null,
      clientHeight: null,
      clientWidth: null,
      clientItem: { data: {} },
    },
  };

  itemsElement = {};

  expandTimer = new DelayedFunction(500);

  getDraggedDom = (draggableId) => {
    const queryAttr = 'id';
    const domQuery = `[${queryAttr}='draggable-${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);

    return draggedDOM;
  };

  onDragStart = (result) => {
    const { onDragStart } = this.props;
    this.dragState = {
      source: result.source,
      destination: result.source,
      mode: result.mode,
    };
    this.setState({
      draggedItemId: result.draggableId,
    });

    this.handleGhostingDragStart(result);

    if (onDragStart) {
      onDragStart(result);
    }
  };

  handleGhostingDragStart = (event) => {
    const draggedDOM = this.getDraggedDom(event.draggableId);

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const sourceIndex = event.source.index;
    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      [...draggedDOM.parentNode.children].slice(0, sourceIndex).reduce((total, curr) => {
        const style = curr.currentStyle || window.getComputedStyle(curr);
        const marginTop = parseFloat(style.marginTop);
        return total + curr.clientHeight + marginTop;
      }, 0);

    // eslint-disable-next-line eqeqeq
    const { item: clientItem } = this.state.flattenedTree.find(
      (element) => element.item.id == event.draggableId,
    );

    const { offsetPerLevel } = this.props;
    const { path: sourceItemPath } = this.state.flattenedTree[sourceIndex];

    this.setState({
      placeholderProps: {
        clientItem,
        clientHeight,
        clientWidth,
        clientY,
        clientX: offsetPerLevel * sourceItemPath.length,
      },
    });
  };

  onDragUpdate = (update) => {
    const { onExpand } = this.props;
    const { flattenedTree } = this.state;
    if (!this.dragState) {
      return;
    }

    this.expandTimer.stop();
    if (update.combine) {
      const { draggableId } = update.combine;
      const item = getItemById(flattenedTree, draggableId);
      if (item && this.isExpandable(item)) {
        this.expandTimer.start(() => onExpand(draggableId, item.path));
      }
    }

    this.handleGhostingDragUpdate(update);

    this.dragState = {
      ...this.dragState,
      destination: update.destination,
      combine: update.combine,
    };
  };

  handleGhostingDragUpdate = (event) => {
    if (!event.destination) {
      return;
    }

    const draggedDOM = this.getDraggedDom(event.draggableId);

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const destinationIndex = event.destination.index;
    const sourceIndex = event.source.index;

    const childrenArray = [...draggedDOM.parentNode.children];
    const movedItem = childrenArray[sourceIndex];
    childrenArray.splice(sourceIndex, 1);

    const updatedArray = [
      ...childrenArray.slice(0, destinationIndex),
      movedItem,
      ...childrenArray.slice(destinationIndex + 2),
    ];

    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
        const style = curr.currentStyle || window.getComputedStyle(curr);
        const marginTop = parseFloat(style.marginTop);
        return total + curr.clientHeight + marginTop + 1;
      }, 0);

    const { flattenedTree } = this.state;

    // eslint-disable-next-line eqeqeq
    const { item: clientItem } = flattenedTree.find(
      (element) => element.item.id == event.draggableId,
    );

    const { offsetPerLevel } = this.props;
    const { path: destinationItemPath, item } = flattenedTree[destinationIndex];
    const { hasChildren: hasDestinationGotChildren } = item;

    const destinationPathDepth = hasDestinationGotChildren
      ? destinationItemPath.length + 1
      : destinationItemPath.length;
    const clientX = offsetPerLevel * destinationPathDepth;

    this.setState({
      placeholderProps: {
        clientItem,
        clientHeight,
        clientWidth,
        clientY,
        clientX,
      },
    });
  };

  onDropAnimating = () => {
    this.expandTimer.stop();
  };

  onDragEnd = (result) => {
    const { onDragEnd, tree, limitItemsToOriginalNestedDepth } = this.props;
    const { flattenedTree } = this.state;
    let isCombine = false;
    this.expandTimer.stop();

    const finalDragState = {
      ...this.dragState,
      source: result.source,
      destination: result.destination,
      combine: result.combine,
    };

    this.setState({
      draggedItemId: undefined,
    });

    let {
      // eslint-disable-next-line prefer-const
      sourcePosition,
      destinationPosition,
      sourcePath,
      destinationPath,
    } = calculateFinalDropPositions(
      tree,
      flattenedTree,
      finalDragState,
      limitItemsToOriginalNestedDepth,
    );

    if (result.combine && !destinationPath) {
      const combineDestination = getDestinationPath(
        flattenedTree,
        result.source.index,
        getIndexById(flattenedTree, result.combine.draggableId),
        this.dragState.horizontalLevel,
      );

      isCombine = true;

      destinationPath = combineDestination;
    }

    onDragEnd(sourcePosition, destinationPosition, sourcePath, destinationPath, isCombine);

    this.dragState = undefined;
  };

  onPointerMove = () => {
    if (this.dragState) {
      this.dragState = {
        ...this.dragState,
        horizontalLevel: this.getDroppedLevel(),
      };
    }
  };

  calculateEffectivePath = (flatItem, snapshot) => {
    const { flattenedTree, draggedItemId } = this.state;

    if (
      this.dragState &&
      draggedItemId === flatItem.item.id &&
      (this.dragState.destination || this.dragState.combine)
    ) {
      const { source, destination, combine, horizontalLevel, mode } = this.dragState;

      // We only update the path when it's dragged by keyboard or drop is animated
      if (mode === 'SNAP' || snapshot.isDropAnimating) {
        if (destination) {
          // Between two items
          return getDestinationPath(
            flattenedTree,
            source.index,
            destination.index,
            horizontalLevel,
          );
        }
        if (combine) {
          return getDestinationPath(
            flattenedTree,
            source.index,
            getIndexById(flattenedTree, combine.draggableId),
            horizontalLevel,
          );
        }
      }
    }
    return flatItem.path;
  };

  isExpandable = (item) => !!item.item.hasChildren && !item.item.isExpanded;

  getDroppedLevel = () => {
    const { offsetPerLevel } = this.props;
    const { draggedItemId } = this.state;

    if (!this.dragState || !this.containerElement) {
      return undefined;
    }

    const containerLeft = getBox(this.containerElement).contentBox.left;
    const itemElement = this.itemsElement[draggedItemId];

    if (itemElement) {
      const currentLeft = getBox(itemElement).contentBox.left;
      const relativeLeft = Math.max(currentLeft - containerLeft, 0);
      return Math.floor((relativeLeft + offsetPerLevel / 2) / offsetPerLevel) + 1;
    }

    return undefined;
  };

  patchDroppableProvided = (provided) => ({
    ...provided,
    innerRef: (el) => {
      this.containerElement = el;
      provided.innerRef(el);
    },
  });

  setItemRef = (itemId, el) => {
    if (el) {
      this.itemsElement[itemId] = el;
    }
  };

  renderItems = () => {
    const { flattenedTree } = this.state;

    return flattenedTree.map((flatItem, index) => this.renderItem(flatItem, index));
  };

  renderItem = (flatItem, index) => {
    const { isDragEnabled } = this.props;

    // If drag and drop is explicitly disabled for all items, render TreeItem directly with stubbed provided and snapshot
    if (isDragEnabled === false) {
      return this.renderTreeItem({
        flatItem,
        path: flatItem.path,
        provided: {
          draggableProps: {
            'data-react-beautiful-dnd-draggable': '',
          },
          innerRef: () => {},
          dragHandleProps: null,
        },
        snapshot: {
          isDragging: false,
          isDropAnimating: false,
        },
      });
    }

    const isDragDisabled =
      typeof isDragEnabled === 'function' ? !isDragEnabled(flatItem.item) : !isDragEnabled;

    return (
      <Draggable
        key={flatItem.item.id}
        draggableId={flatItem.item.id.toString()}
        index={index}
        isDragDisabled={isDragDisabled}
      >
        {this.renderDraggableItem(flatItem)}
      </Draggable>
    );
  };

  renderDraggableItem = (flatItem) => (provided, snapshot) => {
    const currentPath = this.calculateEffectivePath(flatItem, snapshot);

    if (snapshot.isDropAnimating) {
      this.onDropAnimating();
    }
    return this.renderTreeItem({
      flatItem,
      path: currentPath,
      provided,
      snapshot,
    });
  };

  renderTreeItem = ({ flatItem, path, provided, snapshot }) => {
    const { renderItem, onExpand, onCollapse, offsetPerLevel } = this.props;

    return (
      <TreeItem
        key={flatItem.item.id}
        item={flatItem.item}
        path={path}
        onExpand={onExpand}
        onCollapse={onCollapse}
        renderItem={renderItem}
        provided={provided}
        snapshot={snapshot}
        itemRef={this.setItemRef}
        offsetPerLevel={offsetPerLevel}
      />
    );
  };

  render() {
    const renderedItems = this.renderItems();

    const {
      className,
      containerHeight,
      isCombineEnabled,
      isNestingEnabled,
      renderCustomPlaceholder,
      testId,
    } = this.props;

    return (
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
        onDragUpdate={this.onDragUpdate}
      >
        <Droppable
          droppableId="tree"
          isCombineEnabled={isCombineEnabled}
          ignoreContainerClipping
          isNestingEnabled={isNestingEnabled}
        >
          {(provided, snapshot) => {
            const finalProvided = this.patchDroppableProvided(provided);

            return (
              <div
                ref={finalProvided.innerRef}
                className={className}
                data-testid={testId}
                style={{
                  pointerEvents: 'auto',
                  height: containerHeight,
                }}
                onTouchMove={this.onPointerMove}
                onMouseMove={this.onPointerMove}
                {...finalProvided.droppableProps}
              >
                {renderedItems}
                {finalProvided.placeholder}
                {!isEmpty(finalProvided.placeholder) &&
                  snapshot.isDraggingOver &&
                  renderCustomPlaceholder({
                    placeholderProps: this.state.placeholderProps,
                    draggedItemId: this.state.draggedItemId,
                    dragState: this.dragState,
                  })}
              </div>
            );
          }}
        </Droppable>
      </DragDropContext>
    );
  }
}
